export const decodeToken = (token: any) => {
  return JSON.parse(atob(token.split(".")[1]));
};
